"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regionPropType = exports.pageType = exports.componentPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * This PropType represents a `component` object from the ShopperExperience API.
 */
const componentPropType = exports.componentPropType = _propTypes.default.shape({
  data: _propTypes.default.object,
  id: _propTypes.default.string,
  typeId: _propTypes.default.string
});

/**
 * This PropType represents a `region` object from the ShopperExperience API.
 */
const regionPropType = exports.regionPropType = _propTypes.default.shape({
  id: _propTypes.default.string,
  components: _propTypes.default.arrayOf(componentPropType)
});

/**
 * This PropType represents a `page` object from the ShopperExperience API.
 */
const pageType = exports.pageType = _propTypes.default.shape({
  data: _propTypes.default.object,
  description: _propTypes.default.string,
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  regions: _propTypes.default.arrayOf(regionPropType),
  typeId: _propTypes.default.string
});